import { statisticsSelector } from '../../reducers/statistics';

export const UPDATE_STATISTICS = 'UPDATE_STATISTICS';
export const UPDATE_STATISTICS_DATALAKE_VIEW = 'UPDATE_STATISTICS_DATALAKE_VIEW';
export const UPDATE_STATISTICS_DATALAKE_CUSTOM_EVENT = 'UPDATE_STATISTICS_DATALAKE_CUSTOM_EVENT';

export function updateStatistics(payload) {
    return (dispatch, getState) => {
        dispatch([
            {
                type: UPDATE_STATISTICS,
                payload: {
                    orvestoData: payload.orvestoData,
                },
            },
            {
                type: UPDATE_STATISTICS_DATALAKE_VIEW,
                payload: {
                    dataLake: payload.dataLake,
                },
            },
        ]);
    };
}

export function updateHighlightStatistics(highlightSlug, position) {
    return (dispatch, getState) => {
        const prevStatistics = statisticsSelector(getState());

        dispatch({
            type: UPDATE_STATISTICS_DATALAKE_VIEW,
            payload: {
                dataLake: prevStatistics.dataLake,
            },
        });
    };
}

export function updateShareButtonStatistics(prop, svtId) {
    return (dispatch, getState) => {
        dispatch({
            type: UPDATE_STATISTICS_DATALAKE_CUSTOM_EVENT,
            payload: {
                dataLake: {
                    content: {
                        id: svtId,
                    },
                    name: prop,
                },
            },
        });
    };
}
